import {PageHeader} from "../components/PageHeader";
import {LegalDocument} from "../components/LegalDocument";
import {format, legalPages} from "../i18n";
import {legal} from "../legal";

// The refund policy, in src/i18n/en/legal/refunds.md: 30 days, for a license never activated or one that doesn't work
// and support can't fix. Update legal.refundsEffective with any change.
export function RefundsPage() {
    return (
        <div className="legal-text">
            <PageHeader title={legalPages.refunds.title} description={legalPages.refunds.description}/>
            <p className="text-body-secondary">{format(legalPages.effective, { date: legal.refundsEffective })}</p>
            <LegalDocument markdown={legalPages.refunds.document} values={legal}/>
        </div>
    );
}
